import React from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle, Home, ArrowRight } from 'lucide-react';

export default function Error404() {
  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center px-4 text-center pt-20 space-y-6">
      <div className="bg-brand-light p-4 rounded-full text-brand-blue animate-bounce">
        <HelpCircle className="w-16 h-16" />
      </div>
      <div className="space-y-2">
        <h1 className="text-4xl sm:text-5xl font-extrabold text-brand-deep">404 - Siden blev ikke fundet</h1>
        <p className="text-sm sm:text-base text-brand-dark/70 max-w-md mx-auto">
          Beklager, men den side du leder efter findes ikke eller er blevet flyttet. Kontroller venligst URL'en eller gå tilbage til forsiden.
        </p>
      </div>
      <div className="flex flex-col sm:flex-row gap-4 pt-4">
        <Link
          to="/"
          className="bg-brand-blue hover:bg-brand-deep text-white px-6 py-3 rounded-lg font-semibold transition-all duration-200 shadow-md flex items-center justify-center gap-2 text-sm sm:text-base"
        >
          <Home className="w-4 h-4" />
          <span>Gå til forsiden</span>
        </Link>
        <Link
          to="/kontakt"
          className="border border-brand-light hover:bg-brand-light text-brand-deep px-6 py-3 rounded-lg font-semibold transition-all duration-200 flex items-center justify-center gap-2 text-sm sm:text-base"
        >
          <span>Kontakt os</span>
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
